import ImageToText from "./ImageToText/ImageToText";
import { types } from "./types";
import CaptureTextFromImage from "./CaptureTextFromImage/CaptureTextFromImage";



/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
function Actions(
    action,
    showAlert,
    variables,
    setOpenVariable,
    automId,
    variableRender
) {
    switch (action.actionName) {
        case types.IMAGETOTEXT:
            return (
                <ImageToText
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            );
        case types.CAPTURETEXTFROMIMAGE:
            return (
                <CaptureTextFromImage
                    action={action}
                    showAlert={showAlert}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    variableRender={variableRender}
                    automId={automId}
                />
            )
        default: break;
    }
}

export default Actions;
